import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

interface UiState {
    /** Sant når eiendomsvelgeren er åpen i map-first fokus-modus. Skjuler
     *  adressesøk + plan-navigasjon og låser layouten til 50/50 (liste/kart). */
    eiendomsvelgerFocus: boolean;
}

const initialState: UiState = {
    eiendomsvelgerFocus: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setEiendomsvelgerFocus(state, action: PayloadAction<boolean>) {
            state.eiendomsvelgerFocus = action.payload;
        },
    },
});

export const { setEiendomsvelgerFocus } = uiSlice.actions;
export const selectEiendomsvelgerFocus = (s: RootState) => s.ui.eiendomsvelgerFocus;
export default uiSlice.reducer;
